import { render, staticRenderFns } from "./SmartCabinet.vue?vue&type=template&id=07a6d0a3&"
import script from "./SmartCabinet.vue?vue&type=script&lang=js&"
export * from "./SmartCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports